import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { onEnter } from '../../../utilities/accessibility/onEnter'

import '../../../styles/scss/filters/popover-filter-button.scss'

const PopoverFilterButton = forwardRef(({ innerId, isActive, label, onClick }, ref) => (
  <div
    ref={ref}
    id={innerId}
    className={`popover-filter-button ${isActive ? 'popover-filter-button-active' : ''}`}
    onClick={onClick}
    onKeyDown={event => onEnter(event, onClick)}
    role="button"
    tabIndex="0"
  >
    <span>
      {label}
    </span>
  </div>
))

PopoverFilterButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default PopoverFilterButton